import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'task',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'delete_task',
      id: value.id,
    })
  }
}
